<template>
  <div class="large-card" :name="product.id">
    <SearchCompanies class="inner-card-wrapper" :input-id="`search-${product.id}`">
      <template v-slot:label>
        <label class="card-title" :for="`search-${product.id}`">{{ product.title }}</label>
      </template>
      <template v-slot:default>
        <span class="form-text text-center text-sm-start" v-html="product.shortDescription" />
      </template>
    </SearchCompanies>
  </div>
</template>

<script>
import SearchCompanies from './SearchCompanies';

export default {
  props: {
    product: { type: Object, required: true },
  },
  components: {
    SearchCompanies,
  },
};
</script>
